import { FC } from 'react'
import { FormikSelect } from '../../../../components/formik-component'
import { Select } from 'antd'
import { NationalContractLevelEnum, NationalContractReferenceLevelDto, NationalContractType } from '../../../../types'
import { useTranslation } from 'react-i18next'
const { Option } = Select

interface EmployeeNationalLevelSelectProps {
  currentNationalLevel: NationalContractLevelEnum
  nationalReferenceLevels: NationalContractReferenceLevelDto[]
  type: NationalContractType
  name: string
  disabled?: boolean
}

export const EmployeeNationalLevelSelect: FC<EmployeeNationalLevelSelectProps> = ({
  currentNationalLevel,
  nationalReferenceLevels,
  type,
  name,
  disabled,
}) => {
  const [t] = useTranslation()
  const actualDisplayOrder = nationalReferenceLevels.find((nc) => nc.level === currentNationalLevel)!.displayOrder
  const referenceLevels = [...nationalReferenceLevels]
    .filter((item: NationalContractReferenceLevelDto) => item.selectable && actualDisplayOrder < item.displayOrder)
    .sort((a: NationalContractReferenceLevelDto, b: NationalContractReferenceLevelDto) => a.displayOrder - b.displayOrder)
    .map((referenceLevel: NationalContractReferenceLevelDto) => referenceLevel.level)

  return (
    <FormikSelect
      name={name + '.nationalReferenceLevel'}
      placeholder={currentNationalLevel}
      style={{ width: '100%' }}
      optionFilterProp="children"
      size="small"
      allowClear
      disabled={disabled}
    >
      {referenceLevels.map((level, index) => (
        <Option value={level} key={level + index}>
          {`${t(`employee.nationalContract.shortType.${type}`)} ${t(`employee.nationalContract.level.${level}`)}`}
        </Option>
      ))}
    </FormikSelect>
  )
}
